// extracted by mini-css-extract-plugin
export default {"service-gallery":"ServiceGallery_service-gallery__Ve8fC"};